export const CODE_LANGUAGES = {
  text: { name: 'Обычный текст', aliases: ['plain', 'txt'] },
  javascript: { name: 'JavaScript', aliases: ['js'] },
  typescript: { name: 'TypeScript', aliases: ['ts'] },
  json: { name: 'JSON' },
  bash: { name: 'Shell', aliases: ['sh', 'shell'] },
  python: { name: 'Python', aliases: ['py'] },
  sql: { name: 'SQL' },
  html: { name: 'HTML' },
  css: { name: 'CSS' },
};
